import {
  createRouter,
  createWebHistory,
  createWebHashHistory
} from 'vue-router'
import store from '../store';
import routes from '../router/router.js'






const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  base: '/admin',
  routes
});
const getManageIndex ={
    testAuthNav(name) {
      let isShow = false;
      store.state.authList.forEach(t => {
        if (t.pc_url.indexOf(name) != -1) {
          isShow = true;
        }
      })
      return isShow
    },
    manageIndexPath() {
      for(let i in navs){
        let item = navs[i];
        if(getManageIndex.testAuthNav(item.name)){
          if(item.children && item.children.length > 0){
            for(let j in item.children){
              let t = item.children[j];
              if(getManageIndex.testAuthNav(t.name)){
                return t.path;
              }
            }
          }
          return item.path;
        }
      }
      return ''
    }
}

router.beforeEach(async (to, from, next) => {
	//调试开启 放出所有路由
	// next()
	// return
	if(to.path == '/'||to.path == ''){
		next('/home')
		return
	}
	if(to.matched.length == 0 && (to.path != '/'||to.path != '/home')){
		next('/view404')
	}else{
		if(to.fullPath == '/view404' || to.fullPath == '/view403'||to.fullPath=='/camera'){
			next()
		}else{
			if(to.path != '/login'){
				if(!store.state.token){
					next('/login')
				}else{
					if(store.state.userInfo || localStorage.getItem('userInfo')){
						let canMove = null;
						// try{
						// 	canMove = store.state.userInfo.menu_list.find(item=>item.file_path == to.name);
						// }catch(e){
						// 	//TODO handle the exception
						// }
						// if(!!canMove || to.name == 'home'){
						// 	next()
						// }else{
						// 	next('/view403')
						// }
						next()
					}else{
						next('/login')
					}
				}
			}else{
				if(store.state.token){
					next('/home')
				}else{
					next()
				}
			}
		}
	}
})

export default router
